<template>
    <section class="footer-headline">
        <div class="container">
            <div class="headline">
                Cadastre-se agora e<br>
                inicie o seu orçamento
            </div>
            <a href="#register">
                <button class="btn btn-footer-headline" @click="openInstructionsAlert">Quero me cadastrar</button>
            </a>
        </div>
    </section>
</template>

<script>
export default {

    methods: {
        openInstructionsAlert() {
            this.$store.dispatch('modalInstructionsAlert/showModal')
        }
    }
}
</script>